module.exports = __webpack_public_path__ + "static/media/libro15.33e24458.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro15.png
// module id = 363
// module chunks = 0